import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'

const MultilineDiv = styled.div`
    white-space: pre-line;
`

export const MultilineBlock = ({ text }) => (
    <MultilineDiv>{ text }</MultilineDiv>
)

MultilineBlock.propTypes = {
    text: PropTypes.string,
}
